<template>
  <div class="intro-text-image">
    <div class="row-1">
      <div
        class="text-image__container"
        :class="{
          'invert-order': block.invertiOrdine,
        }"
      >
        <div class="text-image__image">
          <div
            v-if="
              block.sezioneContenutoPagina?.length &&
              block.sezioneContenutoPagina[0].custom?.length
            "
          >
            <WidgetPicture
              :image="{
                custom: block.sezioneContenutoPagina[0].custom[0],
              }"
              :alt="block.sezioneContenutoPagina[0].custom[0]?.title"
            />
          </div>
        </div>
        <div class="text-image__text">
          <div class="text-image__content">
            <div v-if="block.title">
              <h1 class="title-medium3" v-html="block.title" />
            </div>
            <div v-if="block.introNews">
              <div class="text-medium" v-html="block.introNews" />
            </div>
          </div>
          <div>
            <NuxtLink
              :to="
                localePath({
                  name: 'news-slug',
                  params: { slug: block.slug },
                })
              "
            >
              <div
                class="text-medium5 default-icon-btn is-medium-bold is-black text-image__cta"
              >
                <span v-html="$t('common.leggi')" />
                <ArrowIcon alt="Arrow icon" class="icon-arrow" />
              </div>
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import ArrowIcon from '@/assets/img/ico/arrow-mobile.svg'

const props = defineProps({
  block: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<script>
export default {
  name: 'IntroTextImage',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
